// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
    firebase: {
      apiKey: 'AIzaSyBvyPK_bkMqXlJGob72XO4Xp22CU0h6dpA',
      authDomain: 'vowel-security.firebaseapp.com',
      databaseURL: 'https://vowel-security.firebaseio.com',
      projectId: 'vowel-security',
      storageBucket: 'vowel-security.firebasestorage.app',
      messagingSenderId: '14024374449',
      appId: '1:14024374449:web:4c0758178e68a540c30a90'
    }
};
